import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInputUp {
    obj_type: string;
    obj_id: string;
    is_hidden: number;
}
export interface IOutputUp {
    data: {};
    error_code: number;
    error_message: string;
}
export const setCircleObjHidden = (data: IInputUp): Promise<IOutputUp> => {
    const url = Api.CIRCLE_SET_OBJ_HIDDEN;
    return fetchData(url, data).then((res: IOutputUp) => {
        return res;
    });
};
